(function(){
    'use strict';
    
    // Theme image loading animation (same mechanic as product media):
    // - Wrap the image in `.media-wrapper`
    // - Set `[loading]` until the image fires `load`/`error`
    // - Add `is="lazy-image"` so theme's lazyimage.js (if enabled) can also manage it
    function ensureMediaWrapper(img){
      if(!img || !img.parentNode) return null;
      // If there is already a media-wrapper somewhere up the tree, use it.
      var existing = img.closest ? img.closest('.media-wrapper') : null;
      if(existing) return existing;
      
      var wrap = document.createElement('span');
      wrap.className = 'media-wrapper media-wrapper--small';
      
      // Keep the same 60x60 sizing the CSS expects on the image.
      wrap.style.width = '60px';
      wrap.style.height = '60px';
      wrap.style.borderRadius = '8px';
      wrap.style.display = 'block';
      wrap.style.overflow = 'hidden';
      
      // Insert wrapper and move image inside
      img.parentNode.insertBefore(wrap, img);
      wrap.appendChild(img);
      return wrap;
    }
    
    function wireThemeLoading(wrapper, img){
      if(!wrapper || !img) return;
      wrapper.setAttribute('loading', 'true');
      var done = function(){ wrapper.removeAttribute('loading'); };
      if(img.complete) return done();
      img.addEventListener('load', function(){
        if(window.requestIdleCallback) window.requestIdleCallback(done, {timeout: 150});
        else setTimeout(done, 0);
      }, { once: true });
      img.addEventListener('error', done, { once: true });
    }
    
    function enhanceUpsellImages(root){
      try{
        var funnels = root && root.querySelectorAll ? root.querySelectorAll('.inline-upsell-funnel') : document.querySelectorAll('.inline-upsell-funnel');
        funnels.forEach(function(funnel){
          if(!funnel || funnel.getAttribute('data-theme-image-loader') === '1') return;
          
          var img = funnel.querySelector('.iu-left img') || funnel.querySelector('img');
          if(!img) { funnel.setAttribute('data-theme-image-loader','1'); return; }
          
          // Add `is="lazy-image"` for theme consistency (CSS keys off this attribute).
          try{
            if(!img.getAttribute('is')) img.setAttribute('is','lazy-image');
          }catch(e){}
          // Small perf hints (don’t change src behavior)
          try{ if(!img.getAttribute('decoding')) img.setAttribute('decoding','async'); }catch(e){}
          
          var wrap = ensureMediaWrapper(img);
          wireThemeLoading(wrap, img);
          
          funnel.setAttribute('data-theme-image-loader','1');
        });
      }catch(e){}
    }
    
    // Initial run
    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', function(){ enhanceUpsellImages(document); }, { once: true });
    } else {
      enhanceUpsellImages(document);
    }
    
    // Catch dynamic re-renders (e.g. quick-view, section reloads)
    try{
      var mo = new MutationObserver(function(muts){
        for(var i=0;i<muts.length;i++){
          var m = muts[i];
          if(m.addedNodes && m.addedNodes.length){
            enhanceUpsellImages(document);
            break;
          }
        }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }catch(e){}
    
    document.addEventListener('click', function(e){
      // Check if clicked on the entire funnel block or just the button
      var root = e.target.closest && e.target.closest('.inline-upsell-funnel');
      if(!root) return;
      
      var variantId = root.getAttribute('data-variant-id');
      if(!variantId) return;
      
      // Find the button
      var btn = root.querySelector('.iu-add');
      if(!btn) return;
  
      btn.disabled = true;
      btn.classList.add('loading');
  
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(function(r){ 
        if (!r.ok) throw new Error('Failed to add to cart');
        return r.json(); 
      })
      .then(function(addResponse){
        return fetch('/cart.js', {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
      })
      .then(function(r){ return r.json(); })
      .then(function(cartData){
        function ensureBubble(container, count){
          if(!container) return;
          var bubble = container.querySelector('.cart-count-bubble');
          if(!bubble && count > 0){
            bubble = document.createElement('span');
            bubble.className = 'cart-count-bubble' + (count >= 100 ? ' cart-count-bubble--dot' : '');
            if(count < 100){
              var inner = document.createElement('span');
              inner.setAttribute('aria-hidden','true');
              inner.textContent = String(count);
              bubble.appendChild(inner);
            }
            // Add visually hidden text for accessibility
            var hidden = document.createElement('span');
            hidden.className = 'visually-hidden';
            hidden.textContent = 'Cart count ' + String(count);
            bubble.appendChild(hidden);
            container.appendChild(bubble);
          } else if(bubble){
            if(count > 0){
              bubble.classList.toggle('cart-count-bubble--dot', count >= 100);
              var num = bubble.querySelector('span[aria-hidden="true"]');
              if(num){
                if(count < 100){ num.textContent = String(count); }
                else { num.textContent = ''; }
              } else if(count < 100){
                var n = document.createElement('span');
                n.setAttribute('aria-hidden','true');
                n.textContent = String(count);
                bubble.insertBefore(n, bubble.firstChild);
              }
              bubble.style.display = '';
            } else {
              bubble.remove();
            }
          }
        }
  
        // Update cart count bubbles first (iOS Safari priority)
        var bubbles = document.querySelectorAll('.cart-count-bubble');
        bubbles.forEach(function(bubble){
          if(cartData.item_count > 0){
            bubble.style.display = '';
            bubble.classList.toggle('cart-count-bubble--dot', cartData.item_count >= 100);
            var countSpan = bubble.querySelector('span[aria-hidden="true"]');
            if(countSpan && cartData.item_count < 100){
              countSpan.textContent = cartData.item_count;
            }
          }
        });
        // Ensure bubbles exist when cart was previously empty
        ensureBubble(document.getElementById('cart-icon-bubble'), cartData.item_count);
        ensureBubble(document.getElementById('mobile-cart-icon-bubble'), cartData.item_count);
        
        // Update mini cart (iOS Safari compatible)
        var miniCart = document.querySelector('mini-cart');
        if(miniCart){
          // Prefer theme.routes.cart_url (supports language prefixes like /en)
          var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url) ? window.theme.routes.cart_url : '/cart';

          // Try silent update first (does NOT open the drawer)
          var sections = miniCart.getSectionsToRender ? miniCart.getSectionsToRender() : [];
          var sectionIds = sections.length > 0
            ? sections.map(function(s){ return s.id || s.section; }).join(',')
            : 'mini-cart,cart-icon-bubble,mobile-cart-icon-bubble';

          fetch(cartUrl + '?sections=' + encodeURIComponent(sectionIds), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          })
          .then(function(r){ return r.json(); })
          .then(function(sectionsData){
            var payload = Object.assign({}, cartData, { sections: sectionsData });
            if(typeof miniCart.renderContentsSilently === 'function'){
              miniCart.renderContentsSilently(payload);
            } else if(typeof miniCart.renderContents === 'function'){
              // Fallback: might open the drawer depending on implementation
              miniCart.renderContents(payload);
            }
          })
          .catch(function(){
            // Fallback: wenn Sections-Fetch fehlschlägt, Drawer nur öffnen
            if(typeof miniCart.open === 'function'){
              miniCart.open();
            }
          });
        }
        
        // Dispatch events (iOS Safari compatible)
        try{
          if(typeof document.dispatchEvent === 'function'){
            var event;
            if(typeof CustomEvent === 'function'){
              event = new CustomEvent('ajaxProduct:added', {
                detail: { product: cartData }
              });
            } else {
              // IE/iOS Safari fallback
              event = document.createEvent('CustomEvent');
              event.initCustomEvent('ajaxProduct:added', true, true, { product: cartData });
            }
            document.dispatchEvent(event);
          }
        }catch(e){}
        
        // Publish cart update
        try{ 
          if(typeof publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate){ 
            publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'inline-upsell-funnel', 
              cartData: cartData
            }); 
          } 
        }catch(e){}
        
        // Success animation
        showSuccessAnimation(btn, root);
        // Fly to cart
        flyToCart(root);
      })
      .catch(function(e){ 
        console.error('Add to cart error:', e);
        btn.disabled = false;
        btn.classList.remove('loading');
      });
    });
    
    function showSuccessAnimation(btn, root) {
      // Remove loading state
      btn.classList.remove('loading');
      
      // Add success state (visual pulse + checkmark)
      btn.classList.add('success');
      
      // Clear any existing timeout
      if (btn._resetTimeout) {
        clearTimeout(btn._resetTimeout);
      }
      
      // Reset after animation
      btn._resetTimeout = setTimeout(function() {
        btn.classList.remove('success');
        btn.disabled = false;
        btn._resetTimeout = null;
      }, 2000);
    }
    
    function flyToCart(root){
      try{
        var img = root.querySelector('.iu-left img');
        if(!img) return;
        var target = pickCartTarget();
        if(!target) return;
        
        // Respect reduced motion
        if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){
          bumpTarget(target);
          return;
        }
        
        var imgRect = img.getBoundingClientRect();
        var targetRect = target.getBoundingClientRect();
        
        var clone = img.cloneNode(true);
        clone.className = (clone.className ? clone.className + ' ' : '') + 'iu-fly-clone';
        clone.style.left = imgRect.left + 'px';
        clone.style.top = imgRect.top + 'px';
        clone.style.width = imgRect.width + 'px';
        clone.style.height = imgRect.height + 'px';
        clone.style.opacity = '0.9';
        clone.style.transform = 'translate3d(0,0,0)';
        
        document.body.appendChild(clone);
        // force reflow
        clone.offsetHeight;
        
        var deltaX = (targetRect.left + (targetRect.width / 2)) - (imgRect.left + (imgRect.width / 2));
        var deltaY = (targetRect.top + (targetRect.height / 2)) - (imgRect.top + (imgRect.height / 2));
        
        clone.style.transform = 'translate(' + deltaX + 'px,' + deltaY + 'px) scale(0.3)';
        clone.style.opacity = '0.2';
        
        var cleanedUp = false;
        function cleanup(){
          if(cleanedUp) return;
          cleanedUp = true;
          if(clone && clone.parentNode){ clone.parentNode.removeChild(clone); }
          bumpTarget(target);
        }
        
        clone.addEventListener('transitionend', cleanup, { once: true });
        setTimeout(cleanup, 700);
      }catch(e){}
    }
    
    function bumpTarget(target){
      if(!target) return;
      var el = target.querySelector ? (target.querySelector('.cart-count-bubble') || target) : target;
      el.classList.add('cart-bump');
      setTimeout(function(){ el.classList.remove('cart-bump'); }, 300);
    }

    function pickCartTarget(){
      // Prefer mobile dock cart bubble when visible; otherwise header cart bubble
      var candidates = [
        document.querySelector('#mobile-cart-icon-bubble .cart-count-bubble'),
        document.getElementById('mobile-cart-icon-bubble'),
        document.querySelector('#cart-icon-bubble .cart-count-bubble'),
        document.getElementById('cart-icon-bubble')
      ];
      for(var i = 0; i < candidates.length; i++){
        if(isVisible(candidates[i])) return candidates[i];
      }
      // Fallbacks
      var fallbacks = [
        document.querySelector('.cart-count-bubble'),
        document.querySelector('.icon-cart'),
        document.querySelector('[data-cart-toggle]'),
        document.querySelector('a[href*="/cart"]')
      ];
      for(i = 0; i < fallbacks.length; i++){
        if(isVisible(fallbacks[i])) return fallbacks[i];
      }
      return null;
    }

    function isVisible(el){
      if(!el) return false;
      try{
        var rect = el.getBoundingClientRect();
        if(rect.width <= 1 && rect.height <= 1) return false;
        if(rect.bottom < 0 || rect.right < 0) return false;
        var vw = window.innerWidth || document.documentElement.clientWidth;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if(rect.top > vh || rect.left > vw) return false;
        var style = window.getComputedStyle(el);
        if(style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
        return true;
      }catch(e){ return false; }
    }
  })();
  